export default __webpack_public_path__ + "static/media/jnh10.af4b72be.jpg";